// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".catalog__title[data-v-04d9638d]{margin-bottom:30px}.catalog__list[data-v-04d9638d]{display:flex;flex-wrap:wrap;margin-top:-30px;margin-left:-30px}.catalog__list>*[data-v-04d9638d]{width:calc(33.33333% - 30px);margin-top:30px;margin-left:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
